@if (variant === 'vertical') {
	<app-top-search-filter-items-vertical
		[filters]="filters"
		[itemMaxWidthPx]="itemMaxWidthPx"
		[showAdvancedHeader]="showAdvancedHeader"
	></app-top-search-filter-items-vertical>
} @else {
	<app-top-search-filter-items-horizontal
		[filters]="filters"
		[itemMaxWidthPx]="itemMaxWidthPx"
	></app-top-search-filter-items-horizontal>
}
